import {
  select,
  put,
  call,
} from 'redux-saga/effects';
import finalize from '@gcc/pip-components/dist/utils/prerender/finalize';
import { updateHarmonyPrice } from '../../actions/parseHarmony'
import {
  updatePricing,
  clearPricing,
  getPricingFromThd,
  getPricingMsrp,
  getPricingSO,
  getPricingError,
  setPricingAvailable,
} from '../../actions/pricingActions';
import {
  updateFulfillmentMethod,
} from '../../actions/cartActions/_actionCreators';
import {
  skuMapSelector,
  configuratorSelector,
  thdStoreInfoSelector,
  configSelector,
  productDetailsAttributeSelector,
} from '../../selectors';
import getThdProductDetailsAndPricing from './getThdProductDetailsAndPricing';
import getMsrpPricing from './getMsrpPricing';
import getSOPricing from './getSOPricing';
import {
  hasError,
} from './_utils';
import getNextFulfillmentMethod from './_getNextFulfillmentMethod';
import {
  CUSTOM_CONFIG_BASED,
} from '../../utils/pipFiguratorType';
import {
  CONFIGURATOR,
} from '../../actions/hydration/constants';
import {
  setHydrationComplete,
} from '../../actions/hydration/orchestration';

export default function* getPricing() {
  const config = yield select(configSelector);
  const {
    storeNumber,
  } = yield select(thdStoreInfoSelector);
  const skuMap = yield select(skuMapSelector);
  const {
    options,
    choices,
  } = yield select(configuratorSelector);
  const {
    bypassSkuMap,
    pipfiguratorType,
    isMajorAppliance,
  } = yield select(productDetailsAttributeSelector);

  if (hasError(options)) {
    yield put(clearPricing());
    return;
  }

  let path;
  try {
    // puts here are for debugging/testing
    // consider making sagas of these paths instead
    // (i.e. yield takeLatest() on their respective actions)
    if (skuMap.skuType === 'HomeDepot_OMSID') {
      yield put(getPricingFromThd());
      path = getThdProductDetailsAndPricing;
    } else if (config.useMSRP) {
      yield put(getPricingMsrp());
      path = getMsrpPricing;
    } else if ((bypassSkuMap && bypassSkuMap === 'True')
      || (pipfiguratorType && pipfiguratorType === CUSTOM_CONFIG_BASED)) {
      yield put(getPricingMsrp());
      path = getMsrpPricing;
    } else {
      yield put(getPricingSO());
      path = getSOPricing;
    }

    // TODO: see if we can move each path's updateProductInfo effect up here too.
    // getThdProductDetails fires off a few more actions after it, but
    // not sure if that's necessary.
    const updatedPricing = yield call(path, skuMap, storeNumber, options, choices);

    
    const { isSpecialBuy, originalPrice, specialPrice } = updatedPricing;
    const specialBuy = isSpecialBuy ? "Special Buys" : null;
    const discount = originalPrice - specialPrice;
    const percent = ( discount / originalPrice ) * 100;
    const propProductData = {
      configuredPrice: {
        pricing : {
          alternate: {
            bulk: {
              value: null,
              thresholdQuantity: null,
            },
            unit: {
              unitsPerCase: null,
              caseUnitOfMeasure: null,
              unitsOriginalPrice: null,
              value: null,
            }
          },
          alternatePriceDisplay: false,
          mapAboveOriginalPrice: null,
          message: null,
          original: originalPrice,
          preferredPriceFlag: null,
          promotion: {
            dates: {
              start : null,
              end: null,
            },
            dollarOff: discount,
            percentageOff: percent,
            savingsCenter: specialBuy,
            savingsCenterPromos: null,
            specialBuySavings: null,
            specialBuyDollarOff: null,
            specialBuyPercentageOff: null,
            type: "DISCOUNT",
          },
          specialBuy: null,
          unitOfMeasure: "each",
          value: specialPrice,
        }
      }
    };
    
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_pricing_event', propProductData);
    const someSkusHaveZeroPrice = updatedPricing?.products?.some((x) => x?.pricing?.originalPrice === 0);

    const numberOfRequestSkus = skuMap?.subSkus?.filter((x) => x.sku).length;
    const numberOfResponseSkus = updatedPricing?.products?.filter((x) => x.itemId).length;
    const clearPrice = isMajorAppliance === 'True'
     && (someSkusHaveZeroPrice || numberOfRequestSkus !== numberOfResponseSkus);

    clearPrice ? yield put(clearPricing()) : yield put(updatePricing(updatedPricing));
    yield put(updateHarmonyPrice());

    yield put(setPricingAvailable());

    const fulfillmentMethod = yield select(getNextFulfillmentMethod);
    yield put(updateFulfillmentMethod(fulfillmentMethod));

    // At the end of pricing call hydration is complete
    yield put(setHydrationComplete(CONFIGURATOR));

    window.prerender && finalize();
  } catch (err) {
    yield put(clearPricing());
    yield put(getPricingError(err));
  }
}
